<div class="empty-state">
  <div class="empty-card" role="status" aria-live="polite">
    <div class="empty-top">
      <div class="empty-icon" aria-hidden="true">
        <app-icon [name]="iconName" size="custom" customSize="28px" color="on-primary-container"></app-icon>
      </div>

      <div class="empty-text">
        <div class="empty-title" tabindex="0">{{ title }}</div>
        <div class="empty-subtitle" tabindex="0">{{ subtitle }}</div>
      </div>
    </div>

    <div class="empty-divider"></div>

    <div class="empty-hint" tabindex="0">{{ hint }}</div>

    <!-- <div class="empty-actions">
                  <button type="button" class="empty-action-btn">
                    <app-icon name="outgoing_mail"></app-icon>
                    Contact care team
                  </button>
                </div> -->
  </div>
</div>
